import { z } from 'zod';

export type OrgRole = z.infer<typeof OrgRole>;

export const OrgRole = z.object({
  orgId: z.string(),
  roleId: z.string(),
});
